module.exports = __webpack_public_path__ + "roboto-italic-webfont.a70faad70f1782029a26.woff";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/assets/fonts/roboto-italic-webfont.woff
// module id = ../../../../../src/assets/fonts/roboto-italic-webfont.woff
// module chunks = styles